module.exports = __webpack_public_path__ + "img/settings-business-details.9bf787b1.svg";